const toolbar = {
  options: ['inline', 'list'],
  inline: {
    inDropdown: false,
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
    options: ['bold', 'italic', 'underline'],
  },
  list: {
    options: [],
  },
};

export default toolbar;
